import React, {Fragment} from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import PollEditor from "../PollEditor";
import FragmentEditor from "../FragmentEditor";
import ModalEditor from "../ModalEditor";
import {loadComponent} from "../../../utils/components";
import Icon from "../../form/Icon";
import Select from "../../form/Select";
import DateTimeInput from "../../form/DateTimeInput";
import QuizAnswerVoteField from './QuizAnswer/QuizAnswerVoteField';
import QuizAnswerVoteLeaderboard from '../lists/QuizAnswerVoteLeaderboard';
 

class QuizAnswerVoteForm extends React.Component {

    render() {
        console.log(this.props);
        return (
            <form onSubmit={this.props.handleSubmit}>
                {this.props.values[this.props.componentConfig.idfield] && this.props.isVoted && <QuizAnswerVoteLeaderboard
                    {...this.props}
                    quiz_id={this.props.values[this.props.componentConfig.idfield]}
                    label="Eredmény"
                />}
                {this.props.values[this.props.componentConfig.idfield] && !this.props.isVoted && <QuizAnswerVoteField
                    {...this.props}
                    quiz_id={this.props.values[this.props.componentConfig.idfield]}
                    label="Válaszok"
                />}
            </form>
        );
    }
}

export default createForm(QuizAnswerVoteForm);
